import { Injectable, inject } from '@angular/core';

import { PickSourceProvider } from '@frontend/sports/option/pick/feature/tracking';
import { TrackData, TrackUpdate, TrackingService } from '@frontend/sports/tracking/feature';
import { isEmpty } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class ModularTrackingService extends TrackingService {
    private pickSourceProvider = inject(PickSourceProvider);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override track(event: string, data?: Partial<TrackData>, options?: any): void {
        super.track(event, this.updateData(data), options);
    }

    override update(data: Partial<TrackUpdate>): void {
        super.update(this.updateData(data));
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    override triggerEventWithCleaning(event?: string, data?: Partial<TrackData>, options?: any): void {
        super.triggerEventWithCleaning(event, this.updateData(data), options);
    }

    private updateData<T>(trackingObject: T): T {
        const baseTracking = this.pickSourceProvider.getTracking();

        return isEmpty(baseTracking)
            ? trackingObject
            : {
                  ...trackingObject,
                  ...baseTracking,
              };
    }
}
